import { useInfiniteQuery } from 'react-query';
import { PAGE_SIZE } from 'utils/constants';
import restFactory from 'v2/utils/restFactory';
import { Activity, DjangoListResponse } from 'v2/models';
import { infiniteActivityKeys } from './activities/query-keys';

export const getKey = (searchId: number) => {
  return [...infiniteActivityKeys.all, 'Searches', searchId];
};

export const useInfiniteSearchActivities = (searchId: number) => {
  return useInfiniteQuery(
    getKey(searchId),
    async ({ pageParam = 1 }) => {
      const res = await restFactory.get<DjangoListResponse<Activity>>(
        `/dj/api/v1/activity/`,
        {
          page: pageParam,
          size: PAGE_SIZE,
          relationships__table_name: 'Searches',
          relationships__object_id: searchId,
          ordering: '-timestamp',
        }
      );

      return {
        ...res,
        prev: pageParam,
        next: pageParam + 1,
      };
    },
    {
      cacheTime: 0,
      refetchOnWindowFocus: false,
      getNextPageParam: (lastPage) => {
        const hasMorePages = PAGE_SIZE * lastPage.prev < lastPage.count;
        return hasMorePages ? lastPage.next : undefined;
      },
    }
  );
};
